import { Store } from 'vuex';
import { Actions, Context } from 'vuex-smart-module';
import OrganizationsStore from '../../store';
import OrganizationsState from '../../store/state';
import OrganizationsSharedGetters from './getters';
import OrganizationsSharedMutations from './mutations';
import OrganizationsSharedState from './state';

export default class OrganizationsSharedActions extends Actions<
  OrganizationsSharedState,
  OrganizationsSharedGetters,
  OrganizationsSharedMutations,
  OrganizationsSharedActions
> {
  organizations_store!: Context<typeof OrganizationsStore>;

  $init(store: Store<OrganizationsState>): void {
    this.organizations_store = OrganizationsStore.context(store);
  }

  get_organizations() {
    return this.organizations_store.actions.get_organizations();
  }
}
